(function () {
  var selector = '[data-ww-scroll-motion]';
  var inViewClass = 'is-in-view';
  var reducedMotionQuery = '(prefers-reduced-motion: reduce)';
  var state = window.WellWiseLandingScrollMotion || {
    observer: null,
    observed: new WeakSet(),
    lastScrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
    scrollingDown: true
  };

  window.WellWiseLandingScrollMotion = state;

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function updateDirection() {
    var scrollY = getScrollY();
    state.scrollingDown = scrollY > state.lastScrollY;
    state.lastScrollY = scrollY;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia(reducedMotionQuery).matches;
  }

  function collectTargets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var targets = [];

    if (scope.matches && scope.matches(selector)) {
      targets.push(scope);
    }

    return targets.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
  }

  function isInViewport(target) {
    var rect = target.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function markInView(target) {
    target.classList.add(inViewClass);

    if (state.observer) {
      state.observer.unobserve(target);
    }
  }

  function markAll(targets) {
    targets.forEach(markInView);
  }

  function getObserver() {
    if (!('IntersectionObserver' in window)) {
      return null;
    }

    if (!state.observer) {
      state.observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          if (!state.scrollingDown) {
            return;
          }

          markInView(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12
      });
    }

    return state.observer;
  }

  function init(root) {
    var targets = collectTargets(root);

    if (!targets.length) {
      return;
    }

    if (prefersReducedMotion()) {
      markAll(targets);
      return;
    }

    var observer = getObserver();

    if (!observer) {
      markAll(targets);
      return;
    }

    targets.forEach(function (target) {
      if (target.classList.contains(inViewClass)) {
        return;
      }

      if (isInViewport(target)) {
        markInView(target);
        return;
      }

      if (!state.observed.has(target)) {
        state.observed.add(target);
        observer.observe(target);
      }
    });
  }

  window.wellWiseLandingScrollMotionInit = init;
  window.addEventListener('scroll', updateDirection, { passive: true });
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', function () { window.requestAnimationFrame(function () { init(document); }); });

  if (document.readyState !== 'loading') {
    init(document);
  }

  if (window.matchMedia) {
    var reducedMotion = window.matchMedia(reducedMotionQuery);
    var handleReducedMotionChange = function () {
      if (reducedMotion.matches) {
        markAll(collectTargets(document));
      }
    };

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleReducedMotionChange);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(handleReducedMotionChange);
    }
  }
})();
